import { render } from "./CheckboxGroup.vue?vue&type=template&id=3a463167"
import script from "./CheckboxGroup.vue?vue&type=script&lang=js"
export * from "./CheckboxGroup.vue?vue&type=script&lang=js"
script.render = render

export default script